abstract class OverviewEventHandlerBase {
    public abstract onAction(pointerToComponentOrUtil, id);
}

export default OverviewEventHandlerBase;